import { publicApi } from "@/lib/api";
import { getDeviceToken } from "@/lib/device";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push not supported on this device");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications denied");

  const reg = await navigator.serviceWorker.ready;
  const { public_key } = await publicApi.vapidPublic();
  if (!public_key) throw new Error("Server missing VAPID key");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key),
    });
  }
  await publicApi.pushSubscribe({
    device_token: getDeviceToken(),
    subscription: sub.toJSON(),
  });
  localStorage.setItem("dr_push_ok", "1");
  return true;
}

export function pushEnabled() {
  return localStorage.getItem("dr_push_ok") === "1";
}
